import type { MarketingCampaign } from '@/api/marketing.api';
import { Button } from '@/components/ui/Button';

type Handlers = {
  onStats: (c: MarketingCampaign) => void;
  onClone: (id: number) => void;
  onSubmit: (id: number) => void;
  onApprove: (id: number) => void;
  onSchedule: (c: MarketingCampaign) => void;
  onLaunch: (id: number) => void;
  onComplete: (id: number) => void;
  onArchive: (id: number) => void;
};

type Props = {
  campaign: MarketingCampaign;
  handlers: Handlers;
};

export function CampaignRowActions({ campaign, handlers }: Props) {
  const s = campaign.lifecycleStatus;
  const terminal = ['ARCHIVED', 'COMPLETED'].includes(s);

  return (
    <div className="flex flex-wrap gap-1">
      <Button variant="ghost" className="text-xs !px-2 !py-1" onClick={() => handlers.onStats(campaign)}>
        Stats
      </Button>
      <Button variant="ghost" className="text-xs !px-2 !py-1" onClick={() => handlers.onClone(campaign.id)}>
        Clone
      </Button>
      {s === 'DRAFT' && (
        <Button variant="ghost" className="text-xs !px-2 !py-1" onClick={() => handlers.onSubmit(campaign.id)}>
          Submit
        </Button>
      )}
      {s === 'REVIEW' && (
        <Button variant="ghost" className="text-xs !px-2 !py-1" onClick={() => handlers.onApprove(campaign.id)}>
          Approve
        </Button>
      )}
      {(s === 'APPROVED' || s === 'SCHEDULED') && (
        <>
          {s === 'APPROVED' && (
            <Button variant="ghost" className="text-xs !px-2 !py-1" onClick={() => handlers.onSchedule(campaign)}>
              Schedule
            </Button>
          )}
          <Button variant="ghost" className="text-xs !px-2 !py-1 text-emerald-700 dark:text-emerald-300" onClick={() => handlers.onLaunch(campaign.id)}>
            Launch
          </Button>
        </>
      )}
      {s === 'RUNNING' && (
        <Button variant="ghost" className="text-xs !px-2 !py-1" onClick={() => handlers.onComplete(campaign.id)}>
          Complete
        </Button>
      )}
      {!terminal && (
        <Button variant="ghost" className="text-xs !px-2 !py-1" onClick={() => handlers.onArchive(campaign.id)}>
          Archive
        </Button>
      )}
    </div>
  );
}
